import { gql } from '@web/federation/gql'

export const DdayRecommendPlacesSectionQuery = gql(`
  query DdayRecommendPlacesSectionQuery {
    ...DdayRecommendPlacesSection_Query
  }

  fragment DdayRecommendPlacesSection_Query on Query {
    me {
      ... on MeSucceed {
        bookingsInNDays(dayCount: 3) {
          bookings {
            id
            placeSummary {
              id
              recommendPlaces {
                ...RecommendPlace
              }
              name
            }
            remainDays
          }
        }
      }
    }
  }

  fragment RecommendPlace on PlaceRecommend {
    id
    images
    placeName
    distance
    categoryName
    reviewCount
  }
`)
